import React, { useLayoutEffect } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);
am4core.options.commercialLicense = true;

const ChartForm = ({ achieve, grade, domainNames, is_result }) => {
  let perColor = is_result ? "#8257ff" : "#04faf8";
  useLayoutEffect(() => {
    let x = am4core.create("chartdiv", am4charts.RadarChart);

    x.padding(30, 30, 30, 30);

    x.data = [
      {
        category: achieve
          ? `${domainNames[0][0]}\n[${perColor}]${(
              achieve[domainNames[0][0]] * 100
            ).toFixed(1)}%`
          : `${domainNames[0][0]}\n[${perColor}]0%`,
        value: achieve ? (achieve[domainNames[0][0]] * 100).toFixed(1) : 0,
        bg20: 20,
        bg40: 40,
        bg60: 60,
        bg80: 80,
        bg100: 100,
      },
      {
        category: achieve
          ? `${domainNames[1][0].replace(" ", "\n")}\n[${perColor}]${(
              achieve[domainNames[1][1]] * 100
            ).toFixed(1)}%`
          : `${domainNames[1][0].replace(" ", "\n")}\n[${perColor}]0%`,
        value: achieve ? (achieve[domainNames[1][1]] * 100).toFixed(1) : 0,
        bg20: 20,
        bg40: 40,
        bg60: 60,
        bg80: 80,
        bg100: 100,
      },
      {
        category: achieve
          ? `${domainNames[2][0].replace(" ", "\n")}\n[${perColor}]${(
              achieve[domainNames[2][1]] * 100
            ).toFixed(1)}%`
          : `${domainNames[2][0]}\n[${perColor}]0%`,
        value: achieve ? (achieve[domainNames[2][1]] * 100).toFixed(1) : 0,
        bg20: 20,
        bg40: 40,
        bg60: 60,
        bg80: 80,
        bg100: 100,
      },
      {
        category: achieve
          ? `${domainNames[3][0].replace(" ", "\n")}\n[${perColor}]${(
              achieve[domainNames[3][1]] * 100
            ).toFixed(1)}%`
          : `${domainNames[3][0]}\n[${perColor}]0%`,
        value: achieve ? (achieve[domainNames[3][1]] * 100).toFixed(1) : 0,
        bg20: 20,
        bg40: 40,
        bg60: 60,
        bg80: 80,
        bg100: 100,
      },
      {
        category: achieve
          ? `${domainNames[4][0].replace(" ", "\n")}\n[${perColor}]${(
              achieve[domainNames[4][1]] * 100
            ).toFixed(1)}%`
          : `${domainNames[4][0]}\n[${perColor}]0%`,
        value: achieve ? (achieve[domainNames[4][1]] * 100).toFixed(1) : 0,
        bg20: 20,
        bg40: 40,
        bg60: 60,
        bg80: 80,
        bg100: 100,
      },
    ];
    var categoryAxis = x.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = "category";
    categoryAxis.renderer.grid.template.disabled = true;

    const label = categoryAxis.renderer.labels.template;
    label.fontWeight = "bold";
    label.fontSize = "14px";
    label.fill = is_result ? "black" : "#fff";
    label.maxWidth = 65;
    label.wrap = true;
    label.textAlign = "middle";

    var valueAxis = x.yAxes.push(new am4charts.ValueAxis());
    valueAxis.renderer.minGridDistance = 20;
    valueAxis.renderer.labels.template.disabled = true;
    valueAxis.renderer.grid.template.stroke = "rgba(255,255,255,0.5)";
    valueAxis.renderer.grid.template.strokeWidth = 1;
    valueAxis.renderer.grid.template.strokeOpacity = 0.5;
    valueAxis.renderer.gridType = "polygons";
    valueAxis.max = 100;
    valueAxis.min = 0;

    function createSeries(name, color) {
      var series = x.series.push(new am4charts.RadarSeries());
      series.showOnInit = false;
      series.dataFields.valueY = name;
      series.dataFields.categoryX = "category";
      series.fillOpacity = 1;
      series.strokeWidth = 0;
      series.fill = color;
    }

    createSeries(
      "bg20",
      is_result ? "rgba(0,0,255,0.05)" : "rgba(255,255,255,0.05)"
    );
    createSeries(
      "bg40",
      is_result ? "rgba(0,0,255,0.05)" : "rgba(255,255,255,0.05)"
    );
    createSeries(
      "bg60",
      is_result ? "rgba(0,0,255,0.05)" : "rgba(255,255,255,0.05)"
    );
    createSeries(
      "bg80",
      is_result ? "rgba(0,0,255,0.05)" : "rgba(255,255,255,0.05)"
    );
    createSeries(
      "bg100",
      is_result ? "rgba(0,0,255,0.05)" : "rgba(255,255,255,0.05)"
    );

    var series = x.series.push(new am4charts.RadarSeries());
    series.dataFields.valueY = "value";
    series.dataFields.categoryX = "category";
    series.fillOpacity = 1;
    series.strokeWidth = 1.5;
    series.stroke = "#fff";
    series.strokeLinecap = "round";
    let gradient = new am4core.LinearGradient();
    gradient.addColor(am4core.color("rgba(0, 233,184,0.6)"));
    gradient.addColor(am4core.color("rgba(0, 150,255,0.6)"));
    gradient.addColor(am4core.color("rgba(155,111,209,0.6)"));
    gradient.rotation = 90;
    series.fill = gradient;
    //chart.current = x;

    return () => {
      x.dispose();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [achieve, grade, domainNames, is_result]);

  return (
    <div
      className="chart"
      style={{ position: "relative", width: "300px", height: "300px" }}
    >
      <div id="chartdiv" style={{ width: "300px", height: "300px" }}></div>
      {achieve ? <></> : <div className="chartMsg">측정 대기 중···</div>}
    </div>
  );
};
export default ChartForm;
